import type { VATCountry } from './types/VATCountry.type';

const countries: Array<VATCountry> = [
  {
    name: 'Austria',
    codes: ['AT', 'AUT', '040'],
    regex: [/^(AT)U(\d{8})$/]
  },
  {
    name: 'Belgium',
    codes: ['BE', 'BEL', '056'],
    regex: [/^(BE)((0|1)?\d{9})$/]
  },
  {
    name: 'Bulgaria',
    codes: ['BG', 'BGR', '100'],
    regex: [/^(BG)(\d{9,10})$/]
  },
  {
    name: 'Croatia',
    codes: ['HR', 'HRV', '191'],
    regex: [/^(HR)(\d{11})$/]
  },
  {
    name: 'Cyprus',
    codes: ['CY', 'CYP', '196'],
    regex: [/^(CY)([0-59]\d{7}[A-Z])$/]
  },
  {
    name: 'Czech Republic',
    codes: ['CZ', 'CZE', '203'],
    regex: [/^(CZ)(\d{8,10})(\d{3})?$/]
  },
  {
    name: 'Denmark',
    codes: ['DK', 'DNK', '208'],
    regex: [/^(DK)(\d{8})$/]
  },
  {
    name: 'Estonia',
    codes: ['EE', 'EST', '233'],
    regex: [/^(EE)(\d{9})$/]
  },
  {
    name: 'Europe',
    codes: ['EU', 'EUR', '000'],
    regex: [/^(EU)(\d{9})$/]
  },
  {
    name: 'Finland',
    codes: ['FI', 'FIN', '246'],
    regex: [/^(FI)(\d{8})$/]
  },
  {
    name: 'France',
    codes: ['FR', 'FRA', '250'],
    regex: [
      /^(FR)(\d{11})$/,
      /^(FR)([A-HJ-NP-Z]\d{10})$/,
      /^(FR)(\d[A-HJ-NP-Z]\d{9})$/,
      /^(FR)([A-HJ-NP-Z]{2}\d{9})$/
    ]
  },
  {
    name: 'Germany',
    codes: ['DE', 'DEU', '276'],
    regex: [/^(DE)([1-9]\d{8})$/]
  },
  {
    name: 'Greece',
    codes: ['GR', 'GRC', '300'],
    regex: [/^(EL)(\d{9})$/]
  },
  {
    name: 'Hungary',
    codes: ['HU', 'HUN', '348'],
    regex: [/^(HU)(\d{8})$/]
  },
  {
    name: 'Ireland',
    codes: ['IE', 'IRL', '372'],
    regex: [
      /^(IE)(\d{7}[A-W])$/,
      /^(IE)([7-9][A-Z*+)]\d{5}[A-W])$/,
      /^(IE)(\d{7}[A-Z][A-Z])$/
    ]
  },
  {
    name: 'Italy',
    codes: ['IT', 'ITA', '380'],
    regex: [/^(IT)(\d{11})$/]
  },
  {
    name: 'Latvia',
    codes: ['LV', 'LVA', '428'],
    regex: [/^(LV)(\d{11})$/]
  },
  {
    name: 'Lithuania',
    codes: ['LT', 'LTU', '440'],
    regex: [/^(LT)(\d{9}|\d{12})$/]
  },
  {
    name: 'Luxembourg',
    codes: ['LU', 'LUX', '442'],
    regex: [/^(LU)(\d{8})$/]
  },
  {
    name: 'Malta',
    codes: ['MT', 'MLT', '470'],
    regex: [/^(MT)([1-9]\d{7})$/]
  },
  {
    name: 'Netherlands',
    codes: ['NL', 'NLD', '528'],
    regex: [/^(NL)(\d{9})B\d{2}$/]
  },
  {
    name: 'Norway',
    codes: ['NO', 'NOR', '578'],
    regex: [/^(NO)(\d{9})$/]
  },
  {
    name: 'Poland',
    codes: ['PL', 'POL', '616'],
    regex: [/^(PL)(\d{10})$/]
  },
  {
    name: 'Portugal',
    codes: ['PT', 'PRT', '620'],
    regex: [/^(PT)(\d{9})$/]
  },
  {
    name: 'Romania',
    codes: ['RO', 'ROU', '642'],
    regex: [/^(RO)([1-9]\d{1,9})$/]
  },
  {
    name: 'Russian Federation',
    codes: ['RU', 'RUS', '643'],
    regex: [/^(RU)(\d{10}|\d{12})$/]
  },
  {
    name: 'Serbia',
    codes: ['RS', 'SRB', '688'],
    regex: [/^(RS)(\d{9})$/]
  },
  {
    name: 'Slovakia',
    codes: ['SK', 'SVK', '703'],
    regex: [/^(SK)([1-9]\d[2346-9]\d{7})$/]
  },
  {
    name: 'Slovenia',
    codes: ['SI', 'SVN', '705'],
    regex: [/^(SI)([1-9]\d{7})$/]
  },
  {
    name: 'Spain',
    codes: ['ES', 'ESP', '724'],
    regex: [
      /^(ES)([A-Z]\d{8})$/,
      /^(ES)([A-HN-SW]\d{7}[A-J])$/,
      /^(ES)([0-9YZ]\d{7}[A-Z])$/,
      /^(ES)([KLMX]\d{7}[A-Z])$/
    ]
  },
  {
    name: 'Sweden',
    codes: ['SE', 'SWE', '752'],
    regex: [/^(SE)(\d{12})$/]
  },
  {
    name: 'Switzerland',
    codes: ['CH', 'CHE', '756'],
    regex: [/^(CHE)(\d{9})(MWST)?$/]
  },
  {
    name: 'United Kingdom',
    codes: ['GB', 'GBR', '826'],
    regex: [
      /^(GB)?(\d{9})$/,
      /^(GB)?(\d{12})$/,
      /^(GB)?(GD\d{3})$/,
      /^(GB)?(HA\d{3})$/
    ]
  }
];

export default countries;
